import { ChevronDownIcon, CloseIcon } from "@chakra-ui/icons";
import {
    Badge,
    Box,
    Button,
    IconButton as ChakraIconButton,
    Checkbox,
    Flex,
    HStack,
    Icon,
    Image,
    Menu,
    MenuButton,
    Stack,
    Text,
    useRadio,
    VStack,
} from "@chakra-ui/react";
import { Avatar, IconButton, Popover, Typography } from "@mui/material";
import { ThemeProvider } from "@mui/material/styles";
import { Dialog } from "primereact/dialog";
import GooglePlacesAutocomplete from "react-google-places-autocomplete";
import { MdAccessTime, MdLocationOn } from "react-icons/md";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { removeUserCardDetails } from "../../actions/card_Details_action";
import { addDeliveryPickupDetails } from "../../actions/delivery_pickup_action";
import { orderInstruction } from "../../actions/order_actions";
import { userLogout } from "../../actions/user_actions";
import Colors from "../../assets/colors/Colors";
import user from "../../assets/images/account.svg";
import bag from "../../assets/images/bag.svg";
import logo from "../../assets/images/Mask.svg";
import payError from "../../assets/images/payError.svg";
import {
    GrubDropDown,
    GrubErrorMessage,
    GrubFormButton,
    GrubProgress,
    GrubTextArea,
} from "../../components/index";
import * as Constants from "../../constants/Constants";
import BackIconButton from "../../modules/auth/components/BackIconButton";
import AuthLayout from "../../modules/auth/screens/AuthLayout";
import FormikErrorText from "../../modules/checkout/components/FormikErrorText";
import HomeText from "../../modules/home/components/HomeText";
import styles from "../../modules/home/styles/home.module.css";
import { WithRouter } from "../../navigators/WithRouter";
import { Mtheme } from "../../theme";
import GiftCardModal from "../GiftCardModal/hooks/GiftCardModal";
import GrubMainProgress from "../loading/GrubMainProgress";
import GrubTitleText from "../title/GrubTitleText";
import useHeader from "./useHeader";

function RadioCard(props) {
    const { getInputProps, getRadioProps } = useRadio(props);

    const input = getInputProps();
    const checkbox = getRadioProps();

    return (
        <Box as="label" m={1} w={{ base: "100%", md: "90%" }}>
            <input {...input} />
            <Box
                {...checkbox}
                cursor="pointer"
                borderWidth="2px"
                borderRadius="md"
                boxShadow="md"
                _checked={{
                    border: "2px solid #5881FE",
                }}
                px={5}
                py={3}
            >
                {props.children}
            </Box>
        </Box>
    );
}

const ErrorMessage = (props) => {
    return (
        <HStack
            minH="3.13rem"
            w={props.width}
            bg="#FFECE2"
            pt="0.5rem"
            pb="0.5rem"
            justifyContent="center"
            alignItems="center"
            alignSelf="center"
            borderRadius="0.44rem"
            mt="0.5rem"
        >
            <Stack
                w={"10%"}
                gap="0.5rem"
                alignItems="center"
                justifyContent="center"
                alignSelf="center"
            >
                <Image src={payError} alt="warning" boxSize="1.5rem" />
            </Stack>
            <Stack w={"90%"}>
                <Text
                    color={Colors.posCancleButtonMuiRed}
                    fontSize={"0.87rem"}
                    lineHeight={"0.95rem"}
                    fontWeight={300}
                >
                    {props.errorMessage}
                </Text>
            </Stack>
        </HStack>
    );
};

const Header = (props) => {
    const {
        isOpen,
        isMobile,
        myContext,
        isLarge,
        isMedium,
        selectedScheduleOptions,
        options,
        group,
        open,
        id,
        isModalOpen,
        anchorEl,
        isGiftCardModalOpen,
        orderType,
        errorMessage,
        isOrderTypeLayout,
        isDeliveryAddress,
        address,
        sheduleTypeLayout,
        timeSlot,
        selectedTimeSlot,
        selectedScheduleType,
        stateData,
        asapTime,
        alreadySavedAddresses,
        selectedPlaceId,
        showNewAddressForm,
        orderInstructionFormik,
        serverPayload,
        isLoading,
        isSmall,
        getRadioProps,
        handleClick,
        handleClose,
        handleOpenModal,
        handleCloseModal,
        handleMenuClick,
        handleGiftCardClick,
        handleSetDelivery,
        handleSelectedScheduleType,
        handleSelectedTimeSlot,
        handleTimeSlot,
        handleModalClose,
        handleChangeDeliveryPickup,
        handlePreviousPage,
        handleToggleNewAddressForm,
        handleSelectedAddress,
        handleSaveDeliveryAddress,
        handleCheckSaveDeliveryAddress,
        handleOrderHistoryClick,
        getTimeSlot,
        handleProfileClick,
    } = useHeader(props);

    return (
        <Flex
            sx={{
                position: "sticky",
                top: 0,
                zIndex: 999,
            }}
        >
            <Dialog
                visible={isOpen}
                style={{
                    width: isLarge ? "38.31rem" : isMedium ? "28.31rem" : "92%",
                    height: isMobile ? "auto" : "42.44rem",
                }}
                onHide={handleModalClose}
                showHeader={false}
                modal={true}
                blockScroll={true}
                className="dialog-overlay"
            >
                {isLoading && <GrubProgress />}
                <Flex
                    justifyContent={
                        isDeliveryAddress || sheduleTypeLayout
                            ? "space-between"
                            : "flex-end"
                    }
                    mt={4}
                >
                    {(isDeliveryAddress || sheduleTypeLayout) && (
                        <BackIconButton
                            iconButton={true}
                            onClick={handlePreviousPage}
                        />
                    )}
                    <ChakraIconButton
                        bg={Colors.posTextAreaBackground}
                        mb="0.88rem"
                        borderRadius="1.5rem"
                        onClick={handleModalClose}
                        height="1.88rem"
                        minW="1.88rem"
                        variant="posghost"
                        icon={
                            <CloseIcon
                                color={Colors.posTextInfo}
                                boxSize="0.75rem"
                                fontWeight="300"
                            />
                        }
                    />
                </Flex>
                <GrubTitleText
                    isLabelText={true}
                    color={Colors.posTextInfo}
                    name={"Order Type"}
                />
                <GrubTitleText
                    isLabelText={true}
                    color={Colors.posTextInfo}
                    fontSize={"0.87rem"}
                    lineHeight={"0.95rem"}
                    fontWeight={300}
                    name={"Please select preferred order type"}
                />
                <Stack
                    mt={{ base: "0.5rem", md: "1.5rem" }}
                    spacing={2}
                    height={{ base: "auto", md: "26rem" }}
                    minHeight={{ base: "20rem", md: "26rem" }}
                    borderRadius="0.44rem"
                    p={{ base: "0.5rem", md: "0" }}
                    border={{
                        base: "0.5px solid #C3D1E6B2",
                        md: "0.5px solid #C3D1E6B2",
                    }}
                    overflowY="auto"
                    justifyContent="flex-start"
                >
                    {isOrderTypeLayout ? (
                        <>
                            <VStack {...group} pt="2rem">
                                {options.map((value) => {
                                    const radio = getRadioProps({
                                        value,
                                    });
                                    return (
                                        <RadioCard key={value} {...radio}>
                                            {value}
                                        </RadioCard>
                                    );
                                })}
                            </VStack>
                            {errorMessage && errorMessage.length > 0 && (
                                <ErrorMessage
                                    errorMessage={errorMessage}
                                    width="90%"
                                />
                            )}
                        </>
                    ) : isDeliveryAddress ? (
                        <VStack pt="2rem">
                            {alreadySavedAddresses.length > 0 &&
                                !showNewAddressForm && (
                                    <Box mb={2} w={{ base: "100%", md: "90%" }}>
                                        <HomeText
                                            isLabelText={true}
                                            name="Saved Addresses"
                                            mb={2}
                                            color={Colors.grubHeaderColor}
                                            fontWeight={400}
                                        />
                                        <VStack spacing={2} align="stretch">
                                            {alreadySavedAddresses.map(
                                                (address, index) => (
                                                    <Stack
                                                        key={index}
                                                        direction={{
                                                            base: "column",
                                                            md: "row",
                                                        }}
                                                        justify="space-between"
                                                        align={{
                                                            base: "flex-start",
                                                            md: "center",
                                                        }}
                                                        p={3}
                                                        borderWidth="1px"
                                                        borderColor="gray.200"
                                                        borderRadius="md"
                                                        _hover={{
                                                            bg: "#C3D1E630",
                                                        }}
                                                        transition="background-color 0.2s"
                                                    >
                                                        <Box
                                                            flex="1"
                                                            mr={{
                                                                base: 0,
                                                                md: 4,
                                                            }}
                                                        >
                                                            <HomeText
                                                                isText={true}
                                                                name={`${address.zipcode}, ${address.address} ${address.city}, ${address.state}`}
                                                                color={
                                                                    Colors.grubHeaderColor
                                                                }
                                                            />
                                                        </Box>
                                                        <GrubFormButton
                                                            width={{
                                                                base: "100%",
                                                                md: "10rem",
                                                            }}
                                                            fontSize={{
                                                                base: "0.75rem",
                                                                lg: "0.94rem",
                                                            }}
                                                            isDisabled={
                                                                selectedPlaceId ==
                                                                address?.place_id
                                                            }
                                                            bg={
                                                                selectedPlaceId ==
                                                                address?.place_id
                                                                    ? Colors.primeTaxInfo
                                                                    : Colors.posTextInfo
                                                            }
                                                            buttonsubmit={
                                                                selectedPlaceId ==
                                                                address?.place_id
                                                                    ? "Selected"
                                                                    : "Select Address"
                                                            }
                                                            onClick={() =>
                                                                handleSelectedAddress(
                                                                    {
                                                                        label: `${address.address}, ${address.city}, ${address.state} ${address.zipcode}`,
                                                                        value: {
                                                                            address:
                                                                                address.address,
                                                                            city: address.city,
                                                                            state: address.state,
                                                                            postal_code:
                                                                                address.zipcode,
                                                                            country:
                                                                                address.country ||
                                                                                "US",
                                                                            place_id:
                                                                                address?.place_id,
                                                                            default_selected: 1,
                                                                        },
                                                                    }
                                                                )
                                                            }
                                                        />
                                                    </Stack>
                                                )
                                            )}
                                        </VStack>
                                        {errorMessage &&
                                            errorMessage.length > 0 && (
                                                <ErrorMessage
                                                    errorMessage={errorMessage}
                                                    width="90%"
                                                />
                                            )}
                                        <Box mt={4}>
                                            <GrubFormButton
                                                bg={Colors.posTextInfo}
                                                buttonsubmit={
                                                    "Add a New Address"
                                                }
                                                width="100%"
                                                height="2.5rem"
                                                fontSize="sm"
                                                onClick={() => {
                                                    handleToggleNewAddressForm(
                                                        true
                                                    );
                                                }}
                                            />
                                        </Box>
                                    </Box>
                                )}
                            {(showNewAddressForm ||
                                alreadySavedAddresses.length == 0) && (
                                <>
                                    <Box mb={2} w={{ base: "100%", md: "90%" }}>
                                        <HomeText
                                            isLabelText={true}
                                            name={"Street Address"}
                                            mb={2}
                                            color={Colors.grubHeaderColor}
                                            fontWeight={400}
                                        />
                                        <GooglePlacesAutocomplete
                                            apiKey={
                                                process.env
                                                    .REACT_APP_GOOGLE_MAPS_API_KEY
                                            }
                                            selectProps={{
                                                placeholder:
                                                    "Enter the delivery address",
                                                isClearable: true,
                                                value: address,
                                                onChange: (val) => {
                                                    handleSetDelivery(val);
                                                },
                                            }}
                                            autocompletionRequest={{
                                                componentRestrictions: {
                                                    country: ["us"],
                                                },
                                            }}
                                        />
                                        {errorMessage &&
                                            errorMessage.length > 0 && (
                                                <ErrorMessage
                                                    errorMessage={errorMessage}
                                                    width="100%"
                                                />
                                            )}
                                    </Box>
                                    <Box mb={2} w={{ base: "100%", md: "90%" }}>
                                        <HomeText
                                            isLabelText={true}
                                            name={"Delivery Instructions"}
                                            mb={2}
                                            mt={2}
                                            color={Colors.grubHeaderColor}
                                            fontWeight={400}
                                        />
                                        <GrubTextArea
                                            id="instruction"
                                            placeholder="e.g ring the bell twice"
                                            size="md"
                                            resize="vertical"
                                            maxLength={500}
                                            value={
                                                orderInstructionFormik.values
                                                    .instruction
                                            }
                                            onChange={(e) => {
                                                orderInstructionFormik.handleChange(
                                                    e
                                                );
                                            }}
                                            onBlur={
                                                orderInstructionFormik.handleBlur
                                            }
                                            inputerror={
                                                orderInstructionFormik.touched
                                                    .instruction &&
                                                orderInstructionFormik.errors
                                                    .instruction
                                            }
                                        />
                                        {orderInstructionFormik.touched
                                            .instruction &&
                                            orderInstructionFormik.errors
                                                .instruction && (
                                                <FormikErrorText
                                                    error={
                                                        orderInstructionFormik
                                                            .errors.instruction
                                                    }
                                                />
                                            )}
                                    </Box>
                                    <HStack w={"90%"}>
                                        <Checkbox
                                            size="lg"
                                            iconColor="white"
                                            fontWeight="bold"
                                            _checked={{
                                                bg: "#5881FE",
                                                borderColor: "#5881FE",
                                                borderRadius: "md",
                                            }}
                                            _focus={{
                                                borderColor: "#5881FE",
                                            }}
                                            colorScheme="transparent"
                                            sx={{
                                                ".chakra-checkbox__control": {
                                                    borderRadius: "md",
                                                },
                                            }}
                                            isChecked={
                                                stateData.saveDeliveryAddress
                                            }
                                            onChange={(e) =>
                                                handleSaveDeliveryAddress(
                                                    e.target.checked
                                                )
                                            }
                                        />
                                        <GrubTitleText
                                            isText={true}
                                            name={
                                                "Save this delivery address for future use"
                                            }
                                            fontSize={{
                                                base: "sm",
                                                md: "md",
                                            }}
                                        />
                                    </HStack>
                                    {alreadySavedAddresses.length > 0 && (
                                        <Box
                                            mt={4}
                                            w={{ base: "100%", md: "90%" }}
                                        >
                                            <GrubFormButton
                                                bg={Colors.posTextInfo}
                                                buttonsubmit={
                                                    "Use Saved Address"
                                                }
                                                width="100%"
                                                height="2.5rem"
                                                fontSize="sm"
                                                onClick={() => {
                                                    handleToggleNewAddressForm(
                                                        false
                                                    );
                                                }}
                                            />
                                        </Box>
                                    )}
                                </>
                            )}
                        </VStack>
                    ) : (
                        sheduleTypeLayout && (
                            <Box
                                w={{ base: "100%", md: "90%" }}
                                justifyContent="center"
                                alignItems="center"
                                alignSelf="center"
                                css={{
                                    "&::-webkit-scrollbar": {
                                        width: "4px",
                                    },
                                    "&::-webkit-scrollbar-track": {
                                        width: "6px",
                                    },
                                    "&::-webkit-scrollbar-thumb": {
                                        background: "gray.200",
                                        borderRadius: "24px",
                                    },
                                }}
                            >
                                <HomeText
                                    isLabelText={true}
                                    color={Colors.primeposTextInfo}
                                    name={"Please Select*"}
                                    fontWeight={400}
                                    mt={4}
                                />
                                <GrubDropDown
                                    width="100%"
                                    lableAvailable={true}
                                    id="selectedSchedule"
                                    value={selectedScheduleType}
                                    filter={false}
                                    dropdownClassName={
                                        styles["p-dropdown-panel"]
                                    }
                                    onChange={(e) => {
                                        if (
                                            undefined != e.value &&
                                            null != e.value &&
                                            "" != e.value
                                        ) {
                                            handleSelectedScheduleType(
                                                e.target.value
                                            );
                                        }
                                    }}
                                    options={selectedScheduleOptions}
                                    optionLabel={"name"}
                                    className="w-full md:w-20rem"
                                    placeholder={"Select Scheduling Type"}
                                />
                                {selectedScheduleType == "custom" ? (
                                    <>
                                        <Box mt={4}>
                                            <HomeText
                                                isLabelText={true}
                                                color={Colors.primeposTextInfo}
                                                name={"Select Time*"}
                                                fontWeight={400}
                                                mt={4}
                                            />
                                        </Box>
                                        <GrubDropDown
                                            width="100%"
                                            lableAvailable={true}
                                            id="selectedSchedule"
                                            value={selectedTimeSlot}
                                            dropdownClassName={
                                                styles["p-dropdown-panel"]
                                            }
                                            onChange={(e) => {
                                                if (
                                                    undefined != e.value &&
                                                    null != e.value &&
                                                    "" != e.value
                                                ) {
                                                    handleSelectedTimeSlot(
                                                        e.target.value
                                                    );
                                                }
                                            }}
                                            filter={false}
                                            options={timeSlot}
                                            optionLabel={"time"}
                                            className="w-full md:w-20rem"
                                            placeholder={"Select Time"}
                                        />
                                        {errorMessage &&
                                            errorMessage.length > 0 && (
                                                <ErrorMessage
                                                    errorMessage={errorMessage}
                                                    width="100%"
                                                />
                                            )}
                                    </>
                                ) : (
                                    typeof stateData === "object" && (
                                        <Box
                                            bg="#BBFBC52E"
                                            border="1px solid"
                                            borderColor="#09B825"
                                            borderRadius="7px"
                                            p={4}
                                            mt={4}
                                            w="100%"
                                        >
                                            <Flex mb={2} align="center">
                                                <Icon
                                                    as={MdAccessTime}
                                                    color="green.500"
                                                    boxSize={5}
                                                    mr={2}
                                                />
                                                <HomeText
                                                    isLabelText={true}
                                                    name={
                                                        orderType == "Delivery"
                                                            ? "Order Delivery Time:"
                                                            : "Order Pickup Time:"
                                                    }
                                                    color={"#04A01D"}
                                                    fontWeight={500}
                                                />
                                            </Flex>
                                            <HomeText
                                                isLabelText={true}
                                                name={
                                                    "Next order will be available Today: " +
                                                    (!asapTime
                                                        ? "N.A."
                                                        : asapTime)
                                                }
                                                color={"#121010B2"}
                                                fontWeight={300}
                                            />
                                        </Box>
                                    )
                                )}
                            </Box>
                        )
                    )}
                    {serverPayload?.message?.length > 0 && (
                        <Box width={{ base: "100%", md: "90%" }} mt={2} ml={4}>
                            <GrubErrorMessage
                                errorMessage={serverPayload?.message}
                                isError={serverPayload?.error}
                                width={"auto"}
                            />
                        </Box>
                    )}
                </Stack>
                <Stack
                    mt={"2rem"}
                    spacing={2}
                    justifyContent="center"
                    alignItems="center"
                    width="100%"
                >
                    <GrubFormButton
                        bg={Colors.posTextInfo}
                        buttonsubmit={sheduleTypeLayout ? "Submit" : "Next"}
                        width="90%"
                        onClick={() => {
                            if (sheduleTypeLayout) {
                                handleCheckSaveDeliveryAddress();
                            } else {
                                handleTimeSlot();
                            }
                        }}
                        autoFocus={false}
                    />
                </Stack>
            </Dialog>
            <Box
                w={"100%"}
                sx={{
                    position: "-webkit-sticky",
                    position: "sticky",
                    top: "0",
                    zIndex: 999,
                }}
            >
                <Box
                    w={"100%"}
                    sx={{
                        position: "absolute",
                        top: "0",
                        zIndex: 99999999,
                    }}
                >
                    {myContext.loading ? <GrubMainProgress /> : null}
                </Box>
                <Flex
                    as="header"
                    direction={{ base: "column", md: "row" }}
                    justifyContent="space-between"
                    alignItems="center"
                    pt={{ base: "0.5rem", md: "1.44rem" }}
                    pr={{ base: isSmall ? "0.2rem" : "1rem", md: "3.06rem" }}
                    pb={{ base: "0.6rem", md: "0.71rem" }}
                    pl={{ base: isSmall ? "0.2rem" : "1rem", md: "4.75rem" }}
                    bg={Colors.PosTextColor}
                    boxShadow="sm"
                    position="sticky"
                    top={{ base: "0.01rem", md: "0.03rem" }}
                    zIndex="sticky"
                >
                    {props.delivery_pickup[0]?.location?.image_url ? (
                        <Image
                            src={props.delivery_pickup[0]?.location?.image_url}
                            alt="Logo"
                            boxSize="3.38rem"
                            display={{ base: "none", md: "flex" }}
                            borderRadius={100}
                            onError={(e) => {
                                e.target.src = logo;
                            }}
                        />
                    ) : (
                        <Image
                            src={logo}
                            alt="Logo"
                            boxSize="3.38rem"
                            display={{ base: "none", md: "flex" }}
                            borderRadius={100}
                        />
                    )}
                    {isMobile ? (
                        <Flex
                            display={{ base: "flex", md: "none" }}
                            justifyContent="space-between"
                            width="100%"
                            spacing={2}
                        >
                            <Box mt={{ base: "0.75rem", md: 0 }}>
                                <Menu
                                    mt={{ base: 2, md: 0 }}
                                    display={{ base: "flex", md: "flex" }}
                                >
                                    <MenuButton
                                        onClick={handleChangeDeliveryPickup}
                                    >
                                        <Flex>
                                            <Icon
                                                as={MdLocationOn}
                                                color={
                                                    Colors.GrubLocationIconColor
                                                }
                                                mr={1}
                                                boxSize="1.19rem"
                                            />
                                            <Box
                                                display="flex"
                                                flexDirection="column"
                                                alignItems="flex-start"
                                            >
                                                {null != getTimeSlot() &&
                                                undefined != getTimeSlot() ? (
                                                    <>
                                                        <GrubTitleText
                                                            isCategoryText={
                                                                true
                                                            }
                                                            fontSize="0.80rem"
                                                            color={
                                                                Colors.posTextInfo
                                                            }
                                                            name={`${
                                                                props
                                                                    .delivery_pickup[0]
                                                                    ?.DeliveryTime
                                                                    ?.time
                                                                    ? `${
                                                                          props
                                                                              .delivery_pickup[0]
                                                                              ?.order_type ===
                                                                          "delivery"
                                                                              ? "Delivery Today,"
                                                                              : "Pickup Today,"
                                                                      }`
                                                                    : `${
                                                                          props
                                                                              .delivery_pickup[0]
                                                                              ?.order_type ===
                                                                          "delivery"
                                                                              ? "Delivery Today,"
                                                                              : "Pickup Today,"
                                                                      }`
                                                            }`}
                                                        />

                                                        <GrubTitleText
                                                            isCategoryText={
                                                                true
                                                            }
                                                            fontSize="0.80rem"
                                                            color={
                                                                Colors.posTextInfo
                                                            }
                                                            name={`${`${
                                                                getTimeSlot()
                                                                    ?.from_time ||
                                                                ""
                                                            } - ${
                                                                getTimeSlot()
                                                                    ?.to_time ||
                                                                ""
                                                            }`}`}
                                                        />
                                                    </>
                                                ) : (
                                                    <Badge
                                                        colorScheme="red"
                                                        borderRadius={100}
                                                        fontSize={"0.80rem"}
                                                        fontWeight={500}
                                                    >
                                                        Shop Closed
                                                    </Badge>
                                                )}
                                            </Box>
                                            <ChevronDownIcon
                                                ml={2}
                                                boxSize="1rem"
                                            />
                                        </Flex>
                                    </MenuButton>
                                </Menu>
                            </Box>
                            <HStack>
                                <Button
                                    variant="outlined"
                                    size="small"
                                    mr={"0.2rem"}
                                    ml={"0.2rem"}
                                    // whiteSpace={"pre-line"}
                                    sx={{
                                        backgroundColor:
                                            Colors.grubOutlinebuttonColor,
                                        color: Colors.posTextInfo,
                                        border: "0.06rem solid #DEEBFF",
                                        borderRadius: "1.25rem",
                                        padding: "0.38rem 0.5rem",
                                        fontWeight: "400",
                                        fontStyle: "normal",
                                        lineHeight: "0.95rem",
                                        fontSize: "0.75rem",
                                        letterSpacing: "-0.02em",
                                    }}
                                    onClick={() => {
                                        handleGiftCardClick(true);
                                    }}
                                >
                                    <Image
                                        src={bag}
                                        alt="Image"
                                        mr="0.2rem"
                                        size="0.75rem"
                                    />
                                    Buy Gift Card
                                </Button>
                                {localStorage.getItem("token") != null &&
                                localStorage.getItem("token") != undefined &&
                                localStorage.getItem("token") != "" &&
                                props.user?.user ? (
                                    <Box>
                                        <IconButton
                                            onClick={(event) =>
                                                handleClick(event, "user")
                                            }
                                            variant="posghost"
                                        >
                                            <Avatar
                                                sx={{
                                                    width: "2rem",
                                                    height: "2rem",
                                                    fontSize: "0.88rem",
                                                    objectFit: "cover",
                                                }}
                                            >
                                                {`${props.user.user.first_name[0].toUpperCase()}${
                                                    props.user.user.last_name &&
                                                    props.user.user.last_name.trim() !==
                                                        ""
                                                        ? props.user.user.last_name[0].toUpperCase()
                                                        : ""
                                                }`}
                                            </Avatar>
                                        </IconButton>
                                        <ThemeProvider theme={Mtheme}>
                                            <Popover
                                                id={id}
                                                open={open}
                                                anchorEl={anchorEl}
                                                onClose={handleClose}
                                                anchorOrigin={{
                                                    vertical: "bottom",
                                                    horizontal: "right",
                                                }}
                                                transformOrigin={{
                                                    vertical: "top",
                                                    horizontal: "right",
                                                }}
                                                sx={{
                                                    "& .MuiPaper-root": {
                                                        overflow: "visible",
                                                        mt: 0.7,
                                                        width: "200px",
                                                        position: "fixed",
                                                        right: "16px !important",
                                                        left: "auto !important",
                                                        "&::before": {
                                                            content: '""',
                                                            position:
                                                                "absolute",
                                                            top: 0,
                                                            right: "20px",
                                                            width: 0,
                                                            height: 0,
                                                            borderLeft:
                                                                "10px solid transparent",
                                                            borderRight:
                                                                "10px solid transparent",
                                                            borderBottom:
                                                                "10px solid #FDFDFD",
                                                            transform:
                                                                "translateY(-100%)",
                                                        },
                                                    },
                                                    "@media (max-width: 768px)":
                                                        {
                                                            "& .MuiPopover-paper":
                                                                {
                                                                    maxWidth:
                                                                        "calc(100% - 32px)",
                                                                    marginTop:
                                                                        "0.5rem",
                                                                },
                                                        },
                                                }}
                                            >
                                                <Box
                                                    mx="auto"
                                                    p={{
                                                        base: "0.19rem",
                                                        md: "1.19rem",
                                                    }}
                                                    bg="white"
                                                    border="1px solid"
                                                    borderColor="gray.200"
                                                    borderRadius="8px"
                                                    boxShadow="0px 2px 5px rgba(0, 0, 0, 0.1)"
                                                    width="100%"
                                                >
                                                    <Typography
                                                        sx={{
                                                            p: 1,
                                                            backgroundColor:
                                                                "#FDFDFD",
                                                            color: "#121010",
                                                            borderRadius: "4px",
                                                            cursor: "pointer",
                                                            "&:hover": {
                                                                backgroundColor:
                                                                    "#C3D1E630",
                                                            },
                                                            fontSize: isMobile
                                                                ? "0.87rem"
                                                                : "1.13rem",
                                                        }}
                                                        onClick={
                                                            handleProfileClick
                                                        }
                                                    >
                                                        My Account
                                                    </Typography>
                                                    <Typography
                                                        sx={{
                                                            p: 1,
                                                            backgroundColor:
                                                                "#FDFDFD",
                                                            color: "#121010",
                                                            borderRadius: "4px",
                                                            cursor: "pointer",
                                                            "&:hover": {
                                                                backgroundColor:
                                                                    "#C3D1E630",
                                                            },
                                                            fontSize: isMobile
                                                                ? "0.87rem"
                                                                : "1.13rem",
                                                        }}
                                                        onClick={
                                                            handleOrderHistoryClick
                                                        }
                                                    >
                                                        Order History
                                                    </Typography>
                                                    <Typography
                                                        sx={{
                                                            p: 1,
                                                            backgroundColor:
                                                                "#FDFDFD",
                                                            color: "#121010",
                                                            borderRadius: "4px",
                                                            cursor: "pointer",
                                                            "&:hover": {
                                                                backgroundColor:
                                                                    "#C3D1E630",
                                                            },
                                                            fontSize: isMobile
                                                                ? "0.87rem"
                                                                : "1.13rem",
                                                        }}
                                                        onClick={
                                                            handleMenuClick
                                                        }
                                                    >
                                                        Logout
                                                    </Typography>
                                                </Box>
                                            </Popover>
                                        </ThemeProvider>
                                    </Box>
                                ) : (
                                    <Box>
                                        <IconButton
                                            onClick={handleOpenModal}
                                            variant="posghost"
                                        >
                                            <Image
                                                src={user}
                                                alt="Image"
                                                boxSize="2rem"
                                                objectFit="cover"
                                                borderRadius="full"
                                            />
                                        </IconButton>
                                    </Box>
                                )}
                            </HStack>
                        </Flex>
                    ) : (
                        <Flex
                            direction={{ base: "column", md: "row" }}
                            align="center"
                        >
                            <Menu
                                mr={{ md: 4 }}
                                display={{ base: "none", md: "flex" }}
                            >
                                <MenuButton
                                    onClick={() => {
                                        if (
                                            null != getTimeSlot() &&
                                            undefined != getTimeSlot()
                                        ) {
                                            handleChangeDeliveryPickup();
                                        }
                                    }}
                                >
                                    <Flex>
                                        <Icon
                                            as={MdLocationOn}
                                            color={Colors.GrubLocationIconColor}
                                            mr={1}
                                            boxSize="1.19rem"
                                        />
                                        <Box
                                            display="flex"
                                            flexDirection="column"
                                            alignItems="flex-start"
                                        >
                                            {null != getTimeSlot() &&
                                            undefined != getTimeSlot() ? (
                                                <>
                                                    <GrubTitleText
                                                        isCategoryText={true}
                                                        color={
                                                            Colors.posTextInfo
                                                        }
                                                        name={`${
                                                            props
                                                                .delivery_pickup[0]
                                                                ?.DeliveryTime
                                                                ?.time
                                                                ? `${
                                                                      props
                                                                          .delivery_pickup[0]
                                                                          ?.order_type ===
                                                                      "delivery"
                                                                          ? "Delivery Today,"
                                                                          : "Pickup Today,"
                                                                  } ${
                                                                      props
                                                                          .delivery_pickup[0]
                                                                          ?.DeliveryTime
                                                                          ?.time
                                                                  }`
                                                                : null !=
                                                                      getTimeSlot() &&
                                                                  undefined !=
                                                                      getTimeSlot()
                                                                ? `${
                                                                      props
                                                                          .delivery_pickup[0]
                                                                          ?.order_type ===
                                                                      "delivery"
                                                                          ? "Delivery Today,"
                                                                          : "Pickup Today,"
                                                                  } ${
                                                                      getTimeSlot()
                                                                          ?.from_time ||
                                                                      ""
                                                                  } - ${
                                                                      getTimeSlot()
                                                                          ?.to_time ||
                                                                      ""
                                                                  }`
                                                                : Constants.STORE_CLOSED
                                                        }`}
                                                    />
                                                    <GrubTitleText
                                                        isHeading={true}
                                                        color={
                                                            Colors.grubHeaderColor
                                                        }
                                                        name={
                                                            props
                                                                .delivery_pickup[0]
                                                                ?.location.name
                                                        }
                                                    />
                                                </>
                                            ) : (
                                                <Badge
                                                    colorScheme="red"
                                                    borderRadius={100}
                                                    fontSize={"0.80rem"}
                                                    fontWeight={500}
                                                >
                                                    Shop Closed
                                                </Badge>
                                            )}
                                        </Box>
                                        <ChevronDownIcon
                                            ml={2}
                                            boxSize="0.75rem"
                                        />
                                    </Flex>
                                </MenuButton>
                            </Menu>
                            <Button
                                variant="outlined"
                                size="small"
                                mr={"1.19rem"}
                                ml={"2.94rem"}
                                display={{ base: "none", md: "flex" }}
                                sx={{
                                    backgroundColor:
                                        Colors.grubOutlinebuttonColor,
                                    color: Colors.posTextInfo,
                                    border: "0.06rem solid #DEEBFF",
                                    borderRadius: "1.25rem",
                                    padding: "0.38rem 1rem",
                                    fontWeight: "400",
                                    fontStyle: "normal",
                                    lineHeight: "1.17rem",
                                    fontSize: "0.94rem",
                                    letterSpacing: "-0.02em",
                                }}
                                onClick={() => {
                                    handleGiftCardClick(true);
                                }}
                            >
                                <Image src={bag} alt="Image" mr="0.63rem" />
                                Buy Gift Card
                            </Button>
                            {localStorage.getItem("token") != null &&
                            localStorage.getItem("token") != undefined &&
                            localStorage.getItem("token") != "" &&
                            props.user?.user ? (
                                <Box>
                                    <IconButton
                                        onClick={(event) =>
                                            handleClick(event, "user")
                                        }
                                        variant="posghost"
                                    >
                                        <Avatar sx={{ width: 36, height: 36 }}>
                                            {`${props.user.user.first_name[0].toUpperCase()}${
                                                props.user.user.last_name &&
                                                props.user.user.last_name.trim() !==
                                                    ""
                                                    ? props.user.user.last_name[0].toUpperCase()
                                                    : ""
                                            }`}
                                        </Avatar>
                                    </IconButton>
                                    <ThemeProvider theme={Mtheme}>
                                        <Popover
                                            id={id}
                                            open={open}
                                            anchorEl={anchorEl}
                                            onClose={handleClose}
                                            anchorOrigin={{
                                                vertical: "bottom",
                                                horizontal: "right",
                                            }}
                                            transformOrigin={{
                                                vertical: "top",
                                                horizontal: "right",
                                            }}
                                            sx={{
                                                "& .MuiPaper-root": {
                                                    overflow: "visible",
                                                    mt: 0.5,
                                                    "&::before": {
                                                        content: '""',
                                                        position: "absolute",
                                                        top: 0,
                                                        right: "58%",
                                                        width: 0,
                                                        height: 0,
                                                        borderLeft:
                                                            "10px solid transparent",
                                                        borderRight:
                                                            "10px solid transparent",
                                                        borderBottom:
                                                            "10px solid #FDFDFD",
                                                        transform:
                                                            "translateY(-100%)",
                                                    },
                                                },
                                            }}
                                        >
                                            <Box
                                                mx="auto"
                                                p="1.19rem"
                                                bg="white"
                                                width={"18.75rem"}
                                                border="1px solid"
                                                borderColor="gray.200"
                                                borderRadius="8px"
                                                boxShadow="0px 2px 5px rgba(0, 0, 0, 0.1)"
                                            >
                                                <Typography
                                                    sx={{
                                                        p: 1.13,
                                                        backgroundColor:
                                                            "#FDFDFD",
                                                        color: "#121010",
                                                        borderRadius: "4px",
                                                        cursor: "pointer",
                                                        "&:hover": {
                                                            backgroundColor:
                                                                "#C3D1E630",
                                                        },
                                                    }}
                                                    onClick={handleProfileClick}
                                                >
                                                    My Account
                                                </Typography>
                                                <Typography
                                                    sx={{
                                                        p: 1.13,
                                                        backgroundColor:
                                                            "#FDFDFD",
                                                        color: "#121010",
                                                        borderRadius: "4px",
                                                        cursor: "pointer",
                                                        "&:hover": {
                                                            backgroundColor:
                                                                "#C3D1E630",
                                                        },
                                                    }}
                                                    onClick={
                                                        handleOrderHistoryClick
                                                    }
                                                >
                                                    Order History
                                                </Typography>
                                                <Typography
                                                    sx={{
                                                        p: 1.13,
                                                        backgroundColor:
                                                            "#FDFDFD",
                                                        color: "#121010",
                                                        borderRadius: "4px",
                                                        cursor: "pointer",
                                                        "&:hover": {
                                                            backgroundColor:
                                                                "#C3D1E630",
                                                        },
                                                    }}
                                                    onClick={handleMenuClick}
                                                >
                                                    Logout
                                                </Typography>
                                            </Box>
                                        </Popover>
                                    </ThemeProvider>
                                </Box>
                            ) : (
                                <>
                                    <Button
                                        display="flex"
                                        justifyContent="center"
                                        alignItems="center"
                                        bg={Colors.PosTextColor}
                                        _hover={{
                                            bg: "transparent !important",
                                        }}
                                        border="0px"
                                        onClick={handleOpenModal}
                                    >
                                        <Image
                                            src={user}
                                            alt="Image"
                                            mr="0.63rem"
                                            display={{
                                                base: "none",
                                                md: "inline",
                                            }}
                                        />
                                        <Text
                                            color={Colors.posTextInfo}
                                            fontWeight="500"
                                            bg="F4F4F4"
                                            size="small"
                                            fontStyle="normal"
                                            lineHeight="1.17rem"
                                            fontSize="0.94rem"
                                            letterSpacing="-0.02em"
                                            display={{
                                                base: "none",
                                                md: "flex",
                                            }}
                                        >
                                            Sign In
                                        </Text>
                                    </Button>
                                </>
                            )}
                        </Flex>
                    )}
                </Flex>
                <GiftCardModal
                    isOpen={isGiftCardModalOpen}
                    onClose={() => handleGiftCardClick(false)}
                />
            </Box>
            <AuthLayout
                isOpen={isModalOpen}
                onClose={handleCloseModal}
                trapFocus={true}
                blockScrollOnMount={true}
                zIndex="popover"
            />
        </Flex>
    );
};

function mapDispatchToProps(dispatch) {
    return bindActionCreators(
        {
            removeUserCardDetails,
            userLogout,
            addDeliveryPickupDetails,
            orderInstruction,
        },
        dispatch
    );
}
function mapStateToProps(state) {
    return {
        user: state.user,
        delivery_pickup: state.delivery_pickup,
        order: state.order,
        payments: state.payments,
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(WithRouter(Header));
